import { render, staticRenderFns } from "./ShopBlock.vue?vue&type=template&id=72cf2c3c&scoped=true"
import script from "./ShopBlock.vue?vue&type=script&lang=js"
export * from "./ShopBlock.vue?vue&type=script&lang=js"
import style0 from "./ShopBlock.vue?vue&type=style&index=0&id=72cf2c3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cf2c3c",
  null
  
)

export default component.exports